<template>
    <div class="greybox">
        <h1>Here are your in progress claim forms</h1>
        <p><strong>Please note:</strong> These claim forms have not been completed / submitted and therefore are not considered open claims!</p>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>Policy Number</th>
                        <th>Date Started / Saved</th>
                        <th>You can...</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="forms.length == 0">
                        <td colspan="3">
                            <span><strong>{{msg}}</strong></span>
                        </td>
                    </tr>
                    <tr v-for="(form, index) in forms" :key="index">
                        <td>{{form.policy}}</td>
                        <td>{{form.createdDate}}</td>
                        <td><a href="javascript:;" @click="handleContinueClick(form.formRef)">Continue</a> / <a href="javascript:;" @click="handleDeleteClick(form.formRef)">Abandon</a></td>
                    </tr>
                    <tr v-if="DEBUG">
                        <td colspan="3">
                            <span><strong>{{forms}}</strong></span>
                        </td>
                    </tr>
                    <tr v-if="DEBUG">
                        <td colspan="3">
                            <span><strong>{{selectedPolicyNumber}} - {{selectedClaimantPostcode}} - {{selectedClaimantDOB}}</strong></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import { formService } from '../services/form-api.service.js'

export default {
  name: 'claimFormList',
  mixins: [

  ],
  components: {

  },
  data () {
    return {
      msg: 'You have no in-progress claim forms.',
      pageNumber: 1,
      pageSize: 10,
      DEBUG: false
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters({
      underwriter: 'claimform/getUnderwriter'
    }),
    forms () {
      return this.$store.state.claimform.inProgressForms
    },
    selectedPolicyNumber () {
      if (this.$store.state.claimform) {
        if (this.$store.state.claimform.claimForm.data.policy) {
          return this.$store.state.claimform.claimForm.data.policy.number
        }
      }
      return null
    },
    selectedClaimantPostcode () {
      if (this.$store.state.claimform) {
        if (this.$store.state.claimform.claimForm.data.claimant) {
          if (this.$store.state.claimform.claimForm.data.claimant.address) {
            return this.$store.state.claimform.claimForm.data.claimant.address.postcode
          }
        }
      }
      return null
    },
    selectedClaimantDOB () {
      if (this.$store.state.claimform) {
        if (this.$store.state.claimform.claimForm.data.claimant) {
          return this.$store.state.claimform.claimForm.data.claimant.dateOfBirth
        }
      }
      return null
    }
  },
  beforeMount () {
    var { pageNumber } = this
    this.load({ pageNumber })
  },
  methods: {
    ...mapActions({
      load: 'claimform/getInProgressFormsList',
      loadForm: 'claimform/getInProgressForm',
      loadFormV2: "claimform/getInProgressFormV2",
      getUnderwriter: 'claimform/getUnderwriter'
    }),
    handleContinueClick (id) {
      // this.loadForm(id)
      //   .then(() => {
      //     console.log(this.$store.state.claimform.standalonePolicy.underwriterId)
      //     this.getUnderwriter(this.$store.state.claimform.standalonePolicy.underwriterId);          
      //     this.$router.push('/makeaclaim/6')
      //   })
      this.loadFormV2(id)
      .then(() => {
        console.log(this.$store.state.claimform.standalonePolicy.underwriterId)
        this.getUnderwriter(this.$store.state.claimform.standalonePolicy.underwriterId);          
        this.$router.push('/makeaclaim/6')
      })
    },
    handleDeleteClick (id) {
      var { pageNumber } = this
      formService.deleteInProgressSingle(id)
        .then(() => {
          this.load({ pageNumber })
        })
    },
    handlePagenationInput (payload) {
      var { pageNumber, pageSize } = this
      this.load({ pageNumber, pageSize })
    }
  }
}
</script>
